var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('ball'),_c('div',{staticClass:"nav"},[_c('Nav',{attrs:{"title":"报告详情","fixed":true}}),_c('div',{staticClass:"top"})],1),_c('div',{ref:"content",staticClass:"pdf"},[_c('pdf',{ref:"myPdfComponent",attrs:{"src":_vm.src}})],1),_c('div',{staticClass:"btn"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }